/**
 * 配信先管理ページ。タブ親（Phase 18: 配信先 / Phase 19: グループ）。
 * 仕様書: docs/01_spec/spec_mail_system.md B-10
 */
import { Screen } from '@/components/layout/Screen';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';

import { ContactsTab } from './ContactsTab';
import { GroupsTab } from './GroupsTab';

export function MailContactsPage() {
  return (
    <Screen
      title="配信先管理"
      description="メール配信先の顧客リストとグループ。CSV 取り込み・AI グルーピングが利用できます。"
    >
      <Tabs defaultValue="contacts">
        <TabsList>
          <TabsTrigger value="contacts">配信先</TabsTrigger>
          <TabsTrigger value="groups">グループ</TabsTrigger>
        </TabsList>
        <TabsContent value="contacts">
          <ContactsTab />
        </TabsContent>
        <TabsContent value="groups">
          <GroupsTab />
        </TabsContent>
      </Tabs>
    </Screen>
  );
}
